import { createFileRoute, useRouteContext } from "@tanstack/react-router";
import AppCard from "@components/AppCard.tsx";
import AssociatedParticipationsDataGrid from "@components/modules/participations/AssociatedParticipationsDataGrid.tsx";
import LaboratoryDocumentsSection from "@components/laboratory/documents/LaboratoryDocumentsSection.tsx";
import { useGetLaboratoryUserQuery } from "@/api/LaboratoryUsersApi";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_USER } from "@/constants";
import { Divider, Typography } from "@mui/material";

export const Route = createFileRoute("/_dashboard/participations-laboratoire/")(
  {
    beforeLoad: (args) => {
      requireRole([ROLE_USER])(args);
    },
    component: RouteComponent,
  }
);

function RouteComponent() {
  const context = useRouteContext({ strict: false });
  const userUuid = context.session!.user!.uuid;
  const { data: laboratoryUser } = useGetLaboratoryUserQuery(userUuid);
  const laboratoryUuid = laboratoryUser?.laboratory?.uuid;

  return (
    <>
      <AppCard title={"Vos modules de laboratoire"}>
        <AssociatedParticipationsDataGrid
          laboratoryUserUuid={userUuid}
          laboratoryParticipationContext
        />
      </AppCard>
    </>
  );
}
